import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { FormBuilder } from '@angular/forms';
import { Logger } from '@app/core';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoHotelSelectComponent');

@Component({
  selector: 'app-kendo-hotel-select',
  templateUrl: './kendo-hotel-select.component.html',
  styleUrls: ['./kendo-hotel-select.component.scss'],
})
export class KendoHotelSelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field = 'hotel_id';

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      hotel_id: [null],
      hotel: [null],
    });

    const hotel = this.getObjectFromStorage(this.field, 'hotels');

    if (hotel) {
      setTimeout(() => {
        this.form.patchValue({
          hotel: hotel,
          hotel_id: hotel.id,
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    CustomKendoFilter.pushObjectInStorage(event, 'hotels');

    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
